module.exports = __webpack_public_path__ + "static/hero4_mob-036812293d4af4e22f95cbba1cb9beee.jpg";